export default __webpack_public_path__ + "static/media/icon-facebook.76ae1428.svg";